import { createTRPCReact, type CreateTRPCReact } from "@trpc/react-query";
import { httpBatchLink, loggerLink } from "@trpc/client";
import type { AppRouter } from "@motorscan/api";

export const trpc: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>();

/**
 * tRPC URL resolution:
 *
 *   - In dev, Vite proxies `/trpc` to the local apps/core (see vite.config.ts).
 *     So both prod and dev hit the same relative path, no rebuild needed.
 *   - The internal-key header is read from VITE_INTERNAL_API_KEY in the
 *     bundle. This is OK for the internal beta — we'll swap to per-user
 *     session tokens once auth lands.
 */
const apiUrl = "/trpc";

export const trpcClientConfig = {
  links: [
    loggerLink({
      enabled: (opts) =>
        (typeof window !== "undefined" && opts.direction === "down" && opts.result instanceof Error) ||
        import.meta.env.DEV,
    }),
    httpBatchLink({
      url: apiUrl,
      fetch(input, init) {
        // Always send cookies so the session cookie travels with every tRPC
        // request — that's how the server picks up the signed-in user.
        return fetch(input, { ...init, credentials: "include" });
      },
      headers: () => {
        const key = import.meta.env.VITE_INTERNAL_API_KEY as string | undefined;
        return key ? { "X-Internal-Key": key } : {};
      },
    }),
  ],
};
